import { render, staticRenderFns } from "./RollLog.vue?vue&type=template&id=0583de39&scoped=true"
import script from "./RollLog.vue?vue&type=script&lang=js"
export * from "./RollLog.vue?vue&type=script&lang=js"
import style0 from "./RollLog.vue?vue&type=style&index=0&id=0583de39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0583de39",
  null
  
)

export default component.exports